import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { log } from 'console';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.scss']
})
export class DeleteUserComponent implements OnInit {
  // [x: string]: any;

  constructor(private modal: NgbActiveModal,private http: HttpClient,private toastr: ToastrService) { }

  ngOnInit() {
  }

  closeModal() {
    this.modal.dismiss();
  }
  deleteUser(){
    let currentUser:any = (localStorage.getItem('USER_INFO'));
    currentUser = JSON.parse(currentUser);
    
    let username = currentUser.username
    // Prepare the data to be sent to the API
    const postData = {
      username: username,
      lock: false,
      userInfoEncrypted: false
    };
    

    // Call the delete user API
    this.http.post('https://forecast.vassarlabs.com/auth/delete-user-api', postData)
      .subscribe(
        response => {
          if(response['success']) {
            this.closeModal();
            this.toastr.success('User Deleted Successfully');
          } else {
            this.toastr.error('Some error occured');
          }
        }
      );
  }
  }

